module.exports = "//static.hsappstatic.net/LoginUI/static-1.14642/img/login-marketing-image.png"